import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Loading } from 'react-style-guide';
import ListOfGamesComponent from '../../gameLists/components/ListOfGamesComponent';
import GameContainerHeader from '../../gameLists/components/GameContainerHeader';
import gamesService from '../../gameData/services/gamesService';
import gamesApiConstants from '../../gameData/constants/gamesApiConstants';
import gameDetailMetaData from '../../gameData/utils/gameDetailMetaData';
import recommendedGamesLayout from '../constants/recommendedGamesLayout';
import placeListsLayout from '../../gameLists/constants/placeListsLayout';

function RecommendedGamesContainer(props) {
  const { translate } = props;
  const [isInitializedLoading, setInitializedLoading] = useState(false);
  const [gamesData, setGamesData] = useState([]);
  const {
    gameDetailPlaceId,
    gameDetailUniverseId,
    gameDetailPageId
  } = gameDetailMetaData.getCurrentGameMetaData();
  const pageContext = { pageId: gameDetailPageId };

  const loadGameList = useCallback(() => {
    if (gameDetailUniverseId) {
      setInitializedLoading(true);
      gamesService
        .getRecommendedGames(gameDetailUniverseId, gamesApiConstants.recommendedGamesParams)
        .then(
          result => {
            if (result?.games) {
              setGamesData(result.games);
            }
          },
          error => {
            console.debug(error);
          }
        )
        .finally(() => {
          setInitializedLoading(false);
        });
    }
  }, [gameDetailUniverseId]);

  useEffect(() => {
    loadGameList();
    return () => {};
  }, [loadGameList]);

  return (
    <React.Fragment>
      {isInitializedLoading ? <Loading /> : null}
      {gamesData.length > 0 && (
        <React.Fragment>
          <GameContainerHeader
            headerLabel={translate(recommendedGamesLayout.titleOfRecommendedGames)}
            isSeeAllHidden
            {...props}
          />
          <ListOfGamesComponent
            gamesData={gamesData}
            sortPosition={1}
            pageType={placeListsLayout.pageTypes.gameDetail}
            isInitializedLoading={isInitializedLoading}
            gameDetailPlaceId={gameDetailPlaceId}
            pageContext={pageContext}
            {...props}
          />
        </React.Fragment>
      )}
    </React.Fragment>
  );
}

RecommendedGamesContainer.propTypes = {
  translate: PropTypes.func.isRequired
};

export default RecommendedGamesContainer;
